import { Component, type ErrorInfo, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

/** Without a boundary any render/effect exception unmounts the whole React
 * tree — the recruiter sees a pure white screen with no explanation. */
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('miniapp render error', error, info);
  }

  override render(): ReactNode {
    if (this.state.error === null) {
      return this.props.children;
    }
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center text-tg-text">
        <h1 className="text-lg font-semibold">Сталася помилка</h1>
        <p className="text-sm text-tg-hint">Закрийте Mini App і відкрийте знову.</p>
        <p className="text-xs text-tg-hint">{this.state.error.message}</p>
        <button
          type="button"
          onClick={() => this.setState({ error: null })}
          className="mt-2 rounded bg-tg-button px-4 py-2 text-sm text-tg-buttonText"
        >
          Спробувати ще раз
        </button>
      </div>
    );
  }
}
